import { mapGetters } from 'vuex'

export default {
  name: 'TheNotification',
  computed: {
    ...mapGetters([
      'showNotification',
      'notificationItemsList',
      'notificationType'
    ])
  }
}
